module.exports = __webpack_public_path__ + "static/media/revocation.dc713bf6.png";